export default __webpack_public_path__ + "static/media/NLP.8a2c9f89.webp";